import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { WA_NAVIGATOR } from '@ng-web-apis/common';

import { SVG } from '@core/consts/SVGs';
import { EXTERNAL_URLS } from '@core/consts/URLs';
import { ButtonComponent } from '@shared/components/button/button.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { TOOLTIP_POSITION } from '@shared/directives/tooltip.consts';

@Component({
  selector: 'mdcr-contacts',
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TooltipDirective],
})
export class ContactsComponent {
  private readonly navigator = inject(WA_NAVIGATOR);

  public readonly SVG = SVG;
  public readonly LINKS = EXTERNAL_URLS;
  public readonly TOOLTIP_POSITION = TOOLTIP_POSITION;

  public copyToClipboard(textToCopy: string): void {
    this.navigator.clipboard.writeText(textToCopy);
  }
}
